<template>
    <div id="account">
        <div v-if="!is_pub"
            class="img-container"
        >
            <img 
                :src="`/static/${client_name}/images/header/logo.png`" 
                alt="客製化版本logo"
            >
        </div>
        <v-row class="info-container"
            justify="space-between"
        >
            <v-col cols="6">
                {{ $t('__acount.account') }}：{{ user }}
            </v-col>
            <v-col cols="4"> 
                <div class="logout-btn"
                    @click="logout"
                >
                    {{ $t('__navbar.logout') }}
                </div>
            </v-col>
        </v-row>
        <v-row
            class="link-container">
            <v-col cols="auto">
                <div v-for="(list, key) in user_customization" 
                    :key="key">
                    <v-btn v-for="(item, idx) in list" 
                        :key="idx"
                        :href="`/${item.name}/`"
                        class="ma-1 link-btn"
                        variant="tonal"
                        rounded="lg"
                        target="_blank"
                        :style="`background-color:${item.color}a6;`">
                        {{ item.c_name }}
                    </v-btn>
                    <br><br>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { logout_ajax } from "@/utils/login.js"
    import { get_user_customization } from "@/utils/login.js"
    import { mapState, mapGetters } from 'vuex'
    export default {
        name: 'Account',
        data() {
            return {
                user_customization: []
            }
        },
        computed: {
            ...mapState([
                'client_name',
                'user'
            ]),

            ...mapGetters([
                'is_pub'
            ]),
        },
		
        methods: {
            async get_user_customization () {
                let result = await get_user_customization(this.client_name);
                if(result && result.status == 'success' && result.data){
                    this.user_customization = result.data
                }
            },
            logout() {
                logout_ajax.call(this, this.client_name);
            },
        },
        mounted(){
            if(!this.is_pub)
                this.get_user_customization()
        }
    }
</script>

<style lang="scss" scoped>
    .img-container {
		text-align: center;
        height: 80px;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.24);
        background-image: linear-gradient(56deg, #304476 13%, #319da9 88%);

        img {
            object-fit: contain;
            width: 100%;
            height: 100%;
        }
    }

	.info-container {
		color: white;
		margin: 0;
	}

	.logout-btn {
		text-align: center;
		cursor: pointer;
		height: 28px;
		border-radius: 16px;
		border: solid 1px #ffffff;
	}

    .link-container {
        overflow-y: auto;
        height: calc(100vh - 150px);
        margin: 0;
    }

    .link-btn {
        color: #fff;
    }
</style>
	